import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Home } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Section, Container } from '@/components/ui/Section';
import { LocalizedLink } from '@/components/LocalizedLink';

export function NotFound() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <>
      <Helmet>
        <title>{t('notFound.pageTitle')}</title>
        <meta name="description" content={t('notFound.metaDescription')} />
        <link rel="canonical" href={`https://www.01sistemi.it/${currentLang}/404`} />
      </Helmet>

      <Section className="min-h-[70vh] flex items-center bg-gradient-to-br from-secondary-50 to-white">
        <Container>
          <div className="text-center max-w-2xl mx-auto">
            {/* 404 Number */}
            <div className="text-6xl sm:text-7xl md:text-9xl font-bold text-primary-400 mb-4">
              404
            </div>

            <h1 className="heading-1 mb-4">
              {t('notFound.title')}
            </h1>

            <p className="body-large text-gray-600 mb-8">
              {t('notFound.description')}
            </p>

            <div className="flex flex-wrap justify-center gap-4">
              <LocalizedLink to="home">
                <Button variant="cta" size="lg">
                  <Home className="w-5 h-5 mr-2" />
                  {t('notFound.backButton')}
                </Button>
              </LocalizedLink>
            </div>
          </div>
        </Container>
      </Section>
    </>
  );
}
